import { useAuth } from "@clerk/clerk-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import useSubscriptionInfo from "@/hooks/useSubscriptionInfo";
import createCheckoutSession from "@/lib/createCheckoutSession";
import { PLANS } from "@/constants/plans";

export default function Billing() {
  const { getToken } = useAuth();
  const { planName, loading } = useSubscriptionInfo();

  const handleUpgrade = async (priceId) => {
    const token = await getToken();
    await createCheckoutSession(priceId, token);
  };

  return (
    <div className="container my-6 max-w-2xl">
      <h1 className="text-3xl font-medium text-foreground mb-2">Billing</h1>
      <p className="text-muted-foreground mb-6">
        Current plan: <span className="font-semibold capitalize">{loading ? "..." : planName}</span>
      </p>

      <div className="space-y-4">
        {PLANS.map((plan) => {
          const isCurrent = !loading && planName === plan.planKey;
          return (
            <div
              key={plan.name}
              className={`border rounded-lg p-5 bg-card flex items-center justify-between ${
                isCurrent ? "border-primary" : "border-border"
              }`}
            >
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <p className="font-semibold text-lg">{plan.name}</p>
                  {isCurrent && (
                    <span className="text-xs bg-primary text-primary-foreground px-2 py-0.5 rounded-full">
                      Current
                    </span>
                  )}
                </div>
                <p className="text-sm text-muted-foreground mb-2">{plan.price}{plan.period}</p>
                <ul className="text-sm space-y-0.5">
                  {plan.features.map((f) => (
                    <li key={f} className="text-muted-foreground">
                      • {f}
                    </li>
                  ))}
                </ul>
              </div>

              {!isCurrent && plan.stripePlanKey && (
                <Button onClick={() => handleUpgrade(plan.planKey)}>Upgrade</Button>
              )}
            </div>
          );
        })}
      </div>

      <p className="text-xs text-muted-foreground mt-6">
        To cancel or manage your subscription, contact support. See{" "}
        <Link to="/pricing" className="underline">
          Pricing
        </Link>{" "}
        for full plan details.
      </p>
    </div>
  );
}
